// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {colors} from '../../../../assets/styles/colors';

import type {Referred} from '../../../../entities';

type Props = {
  referred?: Referred,
};
const useStyles = makeStyles(theme => ({
  gridContainerItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  accordionReferrer: {
    paddingTop: theme.spacing(1),
    borderTop: '1px solid #F4F4F6',
    margin: '0.5rem 0',
    // cursor: 'pointer',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  leftContent: {
    display: 'flex',
    alignItems: 'center',
  },
  rightContent: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapperImage: {
    width: '3rem',
    height: '3rem',
  },
  imgReferrer: {
    width: '4rem',
    height: '4rem',
  },
  nameReferrer: {
    color: '#3A3A49',
    fontSize: '14px',
    fontWeight: '600',
  },
  wrapperPoints: {
    padding: '0.75rem',
    width: '2.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 0.5rem',
    backgroundColor: '#F4F4F6',
    borderRadius: '50%',
    fontSize: '14px',
    color: '#3A3A49',
    fontWeight: '600',
  },
  divider: {
    background: colors.grey300,
    marginTop: theme.spacing(2),
  },
  accordionContent: {
    margin: theme.spacing(1, 0),
    border: '1px solid #F4F4F6',
    borderRadius: '12px',
  },
}));
export default function AccordionReferrer(props: Props) {
  const {referred} = props;
  const classes = useStyles();

  // const [collapsed, setCollapsed] = useState(false);
  return (
    <Grid item xs={12} className={classes.gridContainerItem}>
      {referred ? (
        <div
          className={classes.accordionReferrer}
          // onClick={() => setCollapsed(!collapsed)}
        >
          <div className={classes.leftContent}>
            {/* <div className={classes.wrapperImage}>
              <img
                src={null}
                alt="user-referrer"
                className={classes.imgReferrer}
              />
            </div> */}
            <Typography className={classes.nameReferrer}>
              {referred.name}
            </Typography>
          </div>
          <div className={classes.rightContent}>
            <div className={classes.wrapperPoints}>{referred.totalPoints}</div>
            {/* <div>{collapsed ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div> */}
          </div>
        </div>
      ) : null}
    </Grid>
  );
}

AccordionReferrer.propTypes = {
  referred: PropTypes.object,
};
